import HrPersonForm, { HrPersonFormProps } from 'components/forms/hr/HrPersonForm';

/** Route entry for the modular HR person and related-record forms. */
export default function HrPersonPage(props: HrPersonFormProps) {
  return <HrPersonForm {...props} />;
}
